@if (fieldConfig.type === CarrierFieldConfigType.SELECT) {
  <div>
    <ng-select
      [formControl]="control"
      class="form-input select-field"
      bindLabel="{{ getOptionLabelName() }}"
      bindValue="{{ getOptionValueName() }}"
      placeholder="{{ showSelectPlaceholder && fieldConfig.placeHolder ? fieldConfig.placeHolder : '' }}"
      [required]="
        fieldConfig.isRequired && !(carrierOperationMode === 'TEST' && fieldConfig.isNotRequiredOnTestMode)
          ? true
          : null
      "
      [ngClass]="{ 'invalid-input': showRequiredError() || showValidationError() }"
      (change)="onChangeNgSelect()"
      (clear)="onClearNgSelect()"
      [readonly]="isReadOnly == true"
      [hidden]="isHidden == true">
      @for (option of fieldConfig.options; track option) {
        <ng-option [value]="option.value">
          <span [title]="option.name">{{ option.name }}</span>
        </ng-option>
      }
    </ng-select>
  </div>
}

@if (fieldConfig.type === CarrierFieldConfigType.RADIO_BUTTONS) {
  <div>
    <pdq-radio-group
      #rGroup
      [formControl]="control"
      [required]="
        fieldConfig.isRequired && !(carrierOperationMode === 'TEST' && fieldConfig.isNotRequiredOnTestMode)
          ? true
          : null
      "
      [ngClass]="{ 'invalid-input': showRequiredError() || showValidationError() }"
      [disabled]="isReadOnly == true"
      color="var(--on-surface-default)"
      [hidden]="isHidden == true">
      @for (option of fieldConfig?.options; track option) {
        <pdq-radio-button
          [text]="option?.name"
          [value]="option?.value"
          [checked]="option?.value === fieldConfig?.default">
        </pdq-radio-button>
      }
    </pdq-radio-group>
  </div>
}

@if (fieldConfig.type === CarrierFieldConfigType.TEXT) {
  <input
    placeholder="{{ fieldConfig.placeHolder ? fieldConfig.placeHolder : '' }}"
    [required]="
      fieldConfig.isRequired && !(carrierOperationMode === 'TEST' && fieldConfig.isNotRequiredOnTestMode) ? true : null
    "
    [formControl]="control"
    class="form-input"
    type="text"
    [ngClass]="{ 'invalid-input': showRequiredError() || showValidationError() }"
    autocomplete="off"
    [readonly]="isReadOnly == true"
    [hidden]="isHidden == true" />
}

@if (fieldConfig.type === CarrierFieldConfigType.PASSWORD) {
  <input
    placeholder="{{ fieldConfig.placeHolder ? fieldConfig.placeHolder : '' }}"
    [required]="
      fieldConfig.isRequired && !(carrierOperationMode === 'TEST' && fieldConfig.isNotRequiredOnTestMode) ? true : null
    "
    [formControl]="control"
    class="form-input"
    type="password"
    [ngClass]="{ 'invalid-input': showRequiredError() || showValidationError() }"
    autocomplete="new-password"
    [readonly]="isReadOnly == true"
    [hidden]="isHidden == true" />
}

@if (fieldConfig.type === CarrierFieldConfigType.NUMBER) {
  <input
    placeholder="{{ fieldConfig.placeHolder ? fieldConfig.placeHolder : '' }}"
    [required]="
      fieldConfig.isRequired && !(carrierOperationMode === 'TEST' && fieldConfig.isNotRequiredOnTestMode) ? true : null
    "
    [formControl]="control"
    class="form-input"
    id="input-number"
    type="number"
    (focus)="preventDefaultKeys()"
    [ngClass]="{ 'invalid-input': showRequiredError() || showValidationError() }"
    autocomplete="off"
    [readonly]="isReadOnly == true"
    [hidden]="isHidden == true" />
}

@if (fieldConfig.type === CarrierFieldConfigType.CHECKBOX) {
  <div>
    @for (option of formGroup.get(fieldConfig.fieldName)['controls']; track option; let i = $index) {
      <pdq-checkbox
        [labelSize]="'tiny'"
        [labelVariant]="'secondary'"
        [checked]="option.value.checked"
        (onChange)="option.value.checked = $event"
        [label]="option.value.name"
        [readonly]="isReadOnly == true"
        [hidden]="isHidden == true"></pdq-checkbox>
    }
  </div>
}
@if (fieldConfig.type === CarrierFieldConfigType.TOGGLE) {
  <div>
    <pdq-slide-toggle [defaultValue]="control.value" (onToggle)="control.setValue(!control.value)"></pdq-slide-toggle>
  </div>
}
@if (fieldConfig.type === CarrierFieldConfigType.DATETIME) {
  <div class="date-time-input">
    <pdq-date-input
      height="36px"
      [hidden]="isHidden == true"
      [control]="control"
      [invalidMsg]="'Valid format is MM/DD/YYYY'"
      [invalid]="showRequiredError() || showValidationError()">
    </pdq-date-input>
  </div>
}
@if (fieldConfig.type === CarrierFieldConfigType.TIME) {
  <div class="date-time-input">
    <input
      class="form-input"
      placeholder="{{ fieldConfig.placeHolder ? fieldConfig.placeHolder : 'Choose a time' }}"
      [required]="
        fieldConfig.isRequired && !(carrierOperationMode === 'TEST' && fieldConfig.isNotRequiredOnTestMode)
          ? true
          : null
      "
      [ngxTimepicker]="timePicker"
      [formControl]="control"
      [disableClick]="true"
      [format]="24"
      readonly
      [ngClass]="{ 'invalid-input': showRequiredError() || showValidationError() }"
      [hidden]="isHidden == true" />
    <ngx-material-timepicker-toggle [for]="timePicker" [hidden]="isReadOnly == true">
      <img style="margin-top: 3px" ngxMaterialTimepickerToggleIcon src="assets/icons/icon-calendar.svg" />
    </ngx-material-timepicker-toggle>
    <ngx-material-timepicker #timePicker></ngx-material-timepicker>
  </div>
}

@if (fieldConfig.type === CarrierFieldConfigType.JSON_MAPPING) {
  <div>
    <input
      placeholder="{{ fieldConfig.placeHolder ? fieldConfig.placeHolder : '' }}"
      [required]="fieldConfig.isRequired ? true : null"
      [formControl]="control"
      class="form-input"
      type="text"
      [ngClass]="{ 'invalid-input': showRequiredError() || showValidationError() }"
      autocomplete="off"
      [readonly]="isReadOnly == true"
      hidden="true" />
    <button (click)="openMappingsWindow($event)" mat-flat-button color="primary">Open mappings window</button>
  </div>
}

@if (control?.errors) {
  <div class="error-text-div">
    @if (showRequiredError()) {
      <mat-error>{{ ERROR_REQUIRED_MESSAGE }}</mat-error>
    }
  </div>

  <div *ngIf="showValidationError()">
    {{ fieldConfig.validate?.errorMessage || 'Invalid format.' }}
  </div>
}
